import { LoaderService } from '../../../core/services/loader.service';
import { ChangeDetectorRef, Component, Input } from '@angular/core';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { Store, select } from '@ngrx/store';
import { Router } from '@angular/router';
import { SharedService } from '../../../shared/shared.service';
import {
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';
import { Helper } from '../../../core/helpers/helper';
import {
  MappingUmd,
  getListOfUnMappingUmd,
} from '../../../store/mapping/mapping.actions';
import { Umd } from '../../../shared/modals/common';
import { Validations } from '../../../shared/constants/validations';
import { getListOfUnMappingUmdResponse } from '../../../store/mapping/mapping-selector';
import { MappingService } from '../../../core/services/mapping.services';

@Component({
  selector: 'app-rp-app-mapping',
  templateUrl: './rp-app-mapping.component.html',
  styleUrl: './rp-app-mapping.component.scss',
  standalone: false,
})
export class RpAddMappingComponent {
  @Input() monitoringData!: any;
  configData: any;
  createMappingForm!: UntypedFormGroup;
  submitted: boolean = false;
  Mapping_Validations = Validations.Mapping;
  title: string = 'Create New Mapping';
  projectId: any;
  isFilter: boolean = false;
  unmappedUmdList: any = [];
  filterunmappedUmdList: any[] = [];

  constructor(
    private router: Router,
    private store: Store,
    private modalService: BsModalService,
    private loaderService: LoaderService,
    private sharedService: SharedService,
    private formBuilder: UntypedFormBuilder,
    private cdr: ChangeDetectorRef,
    private mappingService: MappingService
  ) {
    let currentUser = JSON.parse(localStorage.getItem('currentUser') ?? '');
    this.projectId = currentUser?.project.id;
    this.getStoreInfo();
  }
  selectedUmds: any[] = [];
  selectedTowers: any[] = [];
  selectedBlocks: any[] = [];
  selectAllFullList() {
    if (this.isAllSelected()) {
      this.selectedUmds = [];
    } else {
      this.selectedUmds = this.unmappedUmdList.map(
        (item: { id: any }) => item.id
      );
    }
  }
  /*   selectAllFiltered(): void {
      if (!this.filteredUmdList || this.filteredUmdList.length === 0) {
        return;
      }
  
      const filteredIds = this.filteredUmdList.map(item => item.id);
      const currentSelection = new Set(this.selectedUmds ?? []);
  
      for (const id of filteredIds) {
        currentSelection.add(id);
      }
  
      this.selectedUmds = Array.from(currentSelection);
      console.log("kjdsadksadsakdsa----->", this.selectedUmds)
    } */
  selectAllFiltered(): void {
    const filteredIds = this.filteredUmdList.map((item) => item.id);
    const currentSelection = new Set(this.selectedUmds ?? []);

    const allSelected = filteredIds.every((id) => currentSelection.has(id));

    if (allSelected) {
      // Unselect all filtered
      filteredIds.forEach((id) => currentSelection.delete(id));
    } else {
      // Select all filtered
      filteredIds.forEach((id) => currentSelection.add(id));
    }

    this.selectedUmds = Array.from(currentSelection);
  }

  searchTerm: any;
  filteredUmdList: any[] = [];
  searchActive = false;

  onSearch(term: any): void {
    console.log('jdsa-------->', term);
    if (term.items.length === 0) {
      this.searchTerm = term.items;
      this.searchActive = false;
      this.filteredUmdList = [...this.unmappedUmdList];
      return;
    }
    this.searchActive = true;
    // console.log("kjdsadksadsakdsa----->", term)
    // console.log("unmappedUmdList----->", this.unmappedUmdList[5])
    const searchIds = term.items.map((item: { id: any }) => item.id);
    this.filteredUmdList = this.unmappedUmdList.filter((item: { id: any }) =>
      searchIds.includes(item.id)
    );
    //  console.log("filteredUmdList----->", this.filteredUmdList)
  }

  areItemsSelected(): boolean {
    // console.log("filteredUmdList-->",this.filteredUmdList.length)
    // console.log("searchTerm-->", this.searchTerm.length)
    const targetList =
      this.searchTerm.length > 0 ? this.filteredUmdList : this.unmappedUmdList;
    //  console.log("targetList",targetList)
    return (
      targetList.length > 0 &&
      targetList.every((item: { id: any }) =>
        this.selectedUmds.includes(item.id)
      )
    );
  }

  isFilteredSelected(): boolean {
    return this.filteredUmdList.every((item) =>
      this.selectedUmds.includes(item.id)
    );
  }

  isAllSelected(): boolean {
    return (
      this.selectedUmds.length === this.unmappedUmdList.length &&
      this.unmappedUmdList.length > 0
    );
  }

  clearOption(item: any): void {
    const index = this.selectedUmds.indexOf(item.id);
    if (index > -1) {
      this.selectedUmds.splice(index, 1);
      this.revenuDataOnProject();
    }
  }

  clearOptionById(id: string): void {
    const index = this.selectedUmds.indexOf(id);
    if (index > -1) {
      this.selectedUmds.splice(index, 1);
      this.revenuDataOnProject();
    }
  }

  getMacById(id: string): string {
    const item = this.unmappedUmdList.find((i: { id: string }) => i.id === id);
    return item ? item.macAddress : '';
  }

  isSelected(item: any): boolean {
    return this.selectedUmds.includes(item.id);
  }

  revenuDataOnProject(): void {
    console.log('Selected UMDs:', this.selectedUmds);
  }

  getStoreInfo() {
    // this.store.dispatch(resetState());

    let getListOfUnMappingUmdResponse$ = this.store.pipe(
      select(getListOfUnMappingUmdResponse)
    );
    getListOfUnMappingUmdResponse$.subscribe((res: any) => {
      if (res) {
        //console.log(res)
        this.filterunmappedUmdList = [...res];
        this.unmappedUmdList = [...res];
      }
    });
  }
  dismissModal() {
    this.modalService.hide();
  }

  CreateMapping(type: string) {
    this.submitted = true;
    // let projectId = '8d278d1e-7629-4790-cff6-08dc798b288a';
    if (this.createMappingForm.valid) {
      this.store.dispatch(
        MappingUmd({
          id: this.monitoringData.id,
          Umdid: this.createMappingForm.get('utilityId')?.value,
        })
      );
      this.modalService.hide();
    }
  }
  towerList: any[] = [];
  blockList: any[] = [];

  ngOnInit(): void {
    this.createMappingForm = this.formBuilder.group({
      utilityId: [null, Validators.required],
    });

    this.mappingService.getProjectTowerBlocksUrl(this.projectId).subscribe({
      next: (res) => {
        console.log(res.data);
        if (res.statusCode == 200) {


        //  this.towerList = res.data[0].tower;
        //  this.blockList = res.data[0].block;

          this.towerList = [
            {
              id: 'all',
              tower: 'All',
            },
            ...res.data[0].tower,
          ];
          this.blockList = [
            {
              id: 'all',
              block: 'All',
            },
            ...res.data[0].block,
          ];
          console.log( this.towerList)
          console.log( this.blockList)
        }
      },
      error: (err) => {
        console.log(err);
      },
    });
  }
  
  ngAfterViewInit() {
    this.getAllUnMappingUmds();
  }

  getAllUnMappingUmds(): void {
    this.store.dispatch(getListOfUnMappingUmd({ id: this.projectId }));
  }

  onMaterialGroupChange(event: any) {
    console.log(event);
  }

  onRemove(item: any) {
    console.log('Item removed:', item);
    // Add your logic here, like confirmation or syncing with backend
  }

  onChange(updatedSelection: any[]) {
    console.log(this.selectedUmds);
    if (this.selectedUmds) {
      this.searchActive = false;
    }

    //console.log('Updated selection:', updatedSelection);
  }

  towerChange(event: any) {
    // console.log(event);
    if (event.length == 0) {
      this.unmappedUmdList = this.filterunmappedUmdList;
      this.selectedUmds = [];
    } else {
      this.selectedTowers = [];
      event.forEach((item: any) => {
        this.selectedTowers.push(item.tower);
      });
      //console.log(this.selectedTowers)
    }
  }
  blockChange(event: any) {
    if (event.length == 0) {
      this.unmappedUmdList = this.filterunmappedUmdList;
      this.selectedUmds = [];
    } else {
      this.selectedBlocks = [];
      event.forEach((item: any) => {
        this.selectedBlocks.push(item.block);
      });
    }
  }

  filterChange() {
    this.loaderService.setLoading(true);
    
    let request = {
      projectId: this.projectId,
      tower: this.selectedTowers,
      block: this.selectedBlocks,
    };
    /*  let request = {
       projectId: this.projectId,
       tower: this.selectedTowers[0] === 'all' ? null : this.selectedTowers,
       block: this.selectedBlocks[0] === 'all' ? null : this.selectedBlocks,
     }; */
    this.mappingService.unmappedUmdsProjectTowerWiseUrl(request).subscribe({
      next: (res) => {
        this.isFilter = true;
        console.log(res);

        // this.filterunmappedUmdList = [...res.data];
        this.unmappedUmdList = [];
        this.unmappedUmdList = [...res.data];
        this.loaderService.setLoading(false);
      },
      error: (err) => {
        this.loaderService.setLoading(false);

        console.log(err);
      },
    });
  }
}
